/**
 * SubmittedConfirmation — view shown after the form is successfully submitted.
 * Agent calls show_view("submitted_confirmation", { form_name, ref, submitted_at }).
 */

import React from "react";

export default function SubmittedConfirmation({ data = {} }) {
  const { form_name, ref, submitted_at } = data;
  const when = submitted_at ? new Date(submitted_at).toLocaleString() : null;
  return (
    <div style={{ maxWidth: 600, margin: "60px auto", padding: 32, textAlign: "center" }}>
      <div style={{
        fontSize: 48, width: 80, height: 80, margin: "0 auto 24px",
        display: "flex", alignItems: "center", justifyContent: "center",
        borderRadius: "50%", background: "#e8f5e9", color: "#2e7d32",
      }}>✓</div>
      <h2 style={{ margin: "0 0 12px", fontSize: 24 }}>
        {form_name || "Form"} submitted
      </h2>
      <p className="muted" style={{ margin: "0 0 24px" }}>
        {ref
          ? <>Reference: <code style={{ fontFamily: "var(--font-mono, monospace)", background: "#f5f5f5", padding: "2px 6px", borderRadius: 3 }}>{ref}</code></>
          : "Your response has been recorded."}
      </p>
      {when && (
        <p className="muted small" style={{ margin: 0 }}>{when}</p>
      )}
      <p className="muted small" style={{ marginTop: 32, fontStyle: "italic" }}>
        Someone will reach out within 24 hours.
      </p>
    </div>
  );
}
